import styled from 'styled-components';

export const PunchupTagsContainer = styled.div`
	display: flex;
	gap: 16px;
	flex-wrap: nowrap;
	overflow-x: auto;
	overflow-y: hidden;
	padding-bottom: 8px;
	scroll-behavior: smooth;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
`;

export const TagCard = styled.div`
	border-radius: 30px;
	padding: 8px 8px 8px 18px;
	min-width: 100px;
	max-width: 320px;
	flex-shrink: 0;
	background: ${({ theme }) => theme.colors.punchupOrange}10;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	transition: box-shadow 0.2s, border-color 0.2s;
	margin-bottom: 12px;
	display: flex;
	flex-direction: row;
	gap: 10px;
	justify-content: center;
	position: relative;
	height: fit-content;
`;

export const TagName = styled.div`
	font-weight: 600;
	font-size: 16px;
	line-height: 14px;
	margin-bottom: 2px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	gap: 8px;
	width: 100%;
	color: ${({ theme }) => theme.colors.punchupOrange};
`;

export const TagDescription = styled.div`
	font-size: 13px;
	color: #888;
	opacity: 0.9;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-word;
	max-height: 2.8em;
	flex: 1;
`;

export const TagInfoRow = styled.div`
	font-size: 14px;
	color: #222;
	display: flex;
	align-items: center;
	gap: 4px;
	width: 100%;
`;

export const RemoveButton = styled.button`
	background: transparent;
	border: none;
	color: #888;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: all 0.2s;
	color: ${({ theme }) => theme.colors.punchupOrange};

	&:hover {
		transform: scale(1.3);
	}
`;

export const AddTagButton = styled.div`
	border: 2px dashed #e5e5e5;
	border-radius: 14px;
	padding: 20px;
	min-width: 260px;
	max-width: 320px;
	width: 280px;
	flex-shrink: 0;
	background: #fafafa;
	margin-bottom: 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 140px;
	height: 140px;
	cursor: pointer;
	transition: all 0.2s;
	color: #888;
	font-size: 16px;
	font-weight: 600;
	gap: 8px;

	&:hover {
		border-color: #fe5e25;
		background: rgba(254, 94, 37, 0.05);
		color: #fe5e25;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;

		&:hover {
			border-color: #e5e5e5;
			background: #fafafa;
			color: #888;
		}
	}
`;

export const TagsListWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	width: 100%;
	align-items: center;
`;
